import React, { useRef } from "react";

import PropTypes from "prop-types";

import { ReactComponent as IconClosePopUp30 } from "../../icons/icon/30/a-icon-closepopup-30.svg";
import DataLayer from "../../utils/dataLayer";
import BackgroundImage from "../backgroundImage/backgroundImage";
import Button from "../button/button";

import "./imageLightbox.scss";

const ImageLightbox = ({
  backgroundImageStyle,
  headline,
  text,
  buttons = null,
  id,
}) => {
  const lightbox = useRef(null);
  const lightboxWrapper = useRef(null);

  return (
    <div className="image-lightbox d-none" ref={lightbox} id={id}>
      <div className="image-lightbox__wrapper" ref={lightboxWrapper}>
        <div className="image-lightbox__close-button">
          <Button
            variant="text-dark"
            iconOnly
            onClick={() => {
              if (lightbox) {
                lightbox.current.classList.add("d-none");

                if (document?.title) {
                  DataLayer.pushEvent("popup_close", { event_value: document.title });
                }
              }
            }}
          >
            <IconClosePopUp30 />
          </Button>
        </div>
        <BackgroundImage
          className="image-lightbox__image"
          backgroundImageStyle={backgroundImageStyle}
        />
        <div className="image-lightbox__content">
          <div className="image-lightbox__headline">{headline}</div>
          <div className="image-lightbox__text">{text}</div>
          <div className="image-lightbox__buttons">{buttons}</div>
        </div>
      </div>
    </div>
  );
};

ImageLightbox.propTypes = {
  backgroundImageStyle: PropTypes.oneOfType([PropTypes.object]).isRequired,
  buttons: PropTypes.node,
  headline: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default ImageLightbox;
